module.exports = __webpack_public_path__ + "img/exam_4.12d517d2.png";